import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "../../../App";
import { getLoggenInToken,getLoggedInUser } from "../../../store/selectors/AuthSelectors";
import { Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import { exportToExcel } from "./exportToExcel";
import { CSVLink } from "react-csv";
import { Dropdown } from "react-bootstrap";
import SendEmail from "../Common/SendEmail"
import SendLetter from "../Common/SendLetter"
import { dateFormat } from "../../../utils/date";
import {post} from "../../../services/api"
import swal from "sweetalert";
import { toast } from "react-toastify";
import Status from "../Common/Status";

const SearchCompany = ({ token,loggedInUser }) => {
  const nav = useNavigate();
  const userdata = useRef();
  const sendletterref = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPage = 10;
  const [searched, setsearched] = useState(false);
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const [companies, setcompanies]= useState([]);
  const npage = Math.ceil(companies?.length / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);
  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    setCurrentPage(id);
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }
  const options = [
    {value: "companyName", label:"Company Name"},
    {value: "companyRegNo", label:"Company Reg No."},
    {value: "natureOfBusiness", label:"Nature Of Business"},
    {value: "sector", label:"Sector"},
    {value: "business", label:"Business"},
    {value: "address.town", label:"Town"},
    {value: "address.county", label:"County"},
    {value: "address.country", label:"Country"},
    {value: "address.postcode", label:"Postcode"},
    {value: "address.region", label:"Region"},
    {value: "email", label:"Email"},
  ];
  const [searchAnds, setSearchAnds] = useState([{idx:0}]);
  const [searchOrs, setSearchOrs] = useState([]);
  const [checked, setChecked] = useState([]);
  const [unchecked, setUnChecked] = useState(true);
  useEffect(() => {
    setChecked(
      companies?.slice(firstIndex, lastIndex).map((company) => ({
        ...company,
        inputchecked: false,
      }))
    );
  }, [companies, currentPage]);
  useEffect(() => {
    setCurrentPage(1); // Reset to first page on data update
  }, [companies]);
  const handleChecked = (id) => {
    setChecked((prevChecked) =>
      prevChecked.map((company) =>
        company._id === id
          ? { ...company, inputchecked: !company.inputchecked }
          : company
      )
    );
  };
  const handleCheckedAll = (value) => {
    let temp = checked.map((data) => {
      return { ...data, inputchecked: value };
    });
    setChecked(temp);
    setUnChecked(!unchecked);
  };


  const handleInputChange = (idx,field, value) => {
    const serach = [...searchAnds]
    const seechedObject = serach[idx];
    seechedObject[field]=value;
    serach[idx]=seechedObject;
    setSearchAnds(serach);
  };

  const handleInputChange2 = (idx,field, value) => {
    const serach = [...searchOrs]
    const seechedObject = serach[idx];
    seechedObject[field]=value;
    serach[idx]=seechedObject;
    setSearchOrs(serach);
  };

  const searchData = async () => {
    const body = searchAnds.filter(s=> s.field && s.value);
    const orbody = searchOrs.filter(s=> s.field && s.value);
    if(body.length > 0) {
      const res = await post("/api/company/search", { search : body, orsearch: orbody },token);
      setcompanies(res?.data)
      setsearched(true);
    } 
   
  }


  return (
    <>
     <div className='container-fluid'>
				<Row>
					<Col lg="12">
						<div className="card">
							<div className="card-header">
								<h4 className="card-title">Search Companies</h4>
							</div>
							<div className="card-body">
              <div className="row">
                {searchAnds.map((search,idx) => 
                {
                  console.log('search?.field',search?.field)
                  return (
                <>
                {idx !== 0 && <div className="col-xl-1 mb-1" > 
                      <h3 style={{marginTop:'20px',paddingLeft: '10px'}}>And</h3>
                     </div>}
                     
                 <div className="col-xl-5 mb-5 grid-col" style={{ paddingBottom: '10px', borderRadius: '5px'}}>
                 <div className="row" >
               <div className="col-xl-6 mb-6" >
                       <>
                                     <label className="form-label">
                                       Search For
                                       
                                     </label>
                                     <select
                                      //value={search?.field}
                                       className="form-control"
                                       onChange={(e) =>
                                         handleInputChange(idx,"field", e.target.value)
                                       }
                                     >
                                      <option value={null}>Select</option>
                                      {options?.filter(o=>  !searchAnds.filter(s=> s.idx != idx).map(s=>s.field).includes(o.value))?.map((itm) => (
                                         <option value={itm.value}>{itm.label}</option>
                                       ))}
                                     </select>
                                   </>
                                   </div>
                                   <div className="col-xl-6 mb-6">
                                   <>
                                   <label className="form-label">
                                       Equals to
                                       
                                     </label>
                                     <input
                                       type="text"
                                       value={search?.value || ''}
                                       className="form-control"
                                       onChange={(e) =>
                                        handleInputChange(idx,"value", e.target.value)
                                       }
                                     />
                                   </>
                                 
                     </div>
                     </div>
                     </div>

                     
                     </>
                )})}
               

               {searchOrs.map((search,idx) => 
                {
                  return (
                <>
                <div className="col-xl-1 mb-1" > 
                      <h3 style={{marginTop:'20px',paddingLeft: '10px'}}>OR</h3>
                     </div>
                 <div className="col-xl-5 mb-5 grid-col" style={{ paddingBottom: '10px', borderRadius: '5px'}}>
                 <div className="row" >
               <div className="col-xl-6 mb-6" >
                       <>
                                     <label className="form-label">
                                       Search For
                                       
                                     </label>
                                     <select
                                        value={search?.field || ''}
                                       className="form-control"
                                       onChange={(e) =>
                                        handleInputChange2(idx,"field", e.target.value)
                                       }
                                     >
                                      <option value={null}>Select</option>
                                      {options?.map((itm) => (
                                         <option value={itm.value}>{itm.label}</option>
                                       ))}
                                       {/* {options?.filter(o=>  !searchAnds.filter(s=> s.idx != idx).map(s=>s.field).includes(o.value))?.map((itm) => (
                                         <option value={itm.value}>{itm.label}</option>
                                       ))} */}
                                     </select>
                                   </>
                                   </div>
                                   <div className="col-xl-6 mb-6">
                                   <>
                                   <label className="form-label">
                                       Equals to
                                       
                                     </label>
                                     <input
                                       type="text"
                                       value={search?.value || ''}
                                       className="form-control"
                                       onChange={(e) =>
                                        handleInputChange2(idx,"value", e.target.value)
                                       }
                                     />
                                   </>
                                 
                     </div>
                     </div>
                     </div>

                     
                     </>
                )})}

                    <div className="col-xl-6 mb-6">
                      <div style={{marginTop: '20px'}}>
                      
                      {!searched && <button className="btn btn-primary me-2" onClick={()=>{
                        const ands = [...searchAnds];
                        ands.push({idx: ands.length});
                        setSearchAnds(ands)
                      }}>
                         <i className="fa-solid fa-plus me-2"></i>
                          AND
                        </button>}
                        {!searched && <button className="btn btn-primary me-2" onClick={()=>{
                        const ors = [...searchOrs];
                        ors.push({idx: ors.length});
                        setSearchOrs(ors)
                      }}>
                         <i className="fa-solid fa-plus me-2"></i>
                          OR
                        </button>}
                        {!searched && <button className="btn btn-primary me-2" onClick={searchData}>
                        <i className="fa-solid fa-search me-2"></i>
                          Search
                        </button>}

                        <button className="btn btn-primary me-2" onClick={()=>{setsearched(false);setcompanies([]);setSearchAnds([{idx:0}]);setSearchOrs([])}}>
                        <i className="fa-solid fa-close me-2"></i>
                          Clear
                        </button>
                        {searched && 
                        
                        
                        
                        <button className="btn btn-primary me-2" onClick={()=> userdata.current.showEmailModal()}
                        disabled={checked.filter(d=>d.inputchecked)?.length === 0}
                        >
                        <i className="fa-solid fa-envelope me-2"></i>
                          Send Mail
                        </button>}
                        {searched && 
                        <button className="btn btn-primary me-2" 
                        onClick={()=> sendletterref.current.showLetterModal()}
                        disabled={checked.filter(d=>d.inputchecked)?.length === 0}
                        >
                        <i className="fa-solid fa-envelope me-2"></i>
                          Send Letter
                        </button>}

                        {searched &&
                        <button
                  onClick={() =>
                    exportToExcel(
                      checked.filter((itm) => itm.inputchecked).length > 0
                        ? checked.filter((itm) => itm.inputchecked)
                        : companies
                    )
                  }
                  className="btn btn-primary light"
                >
                  <i className="fa-solid fa-file-excel" /> Export Report
                </button>}
                        </div>
                       
                    </div>
                    </div>
                  

              <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
              {checked?.length > 0 && <div className="tbl-caption">
              <h4 className="heading mb-0">Searched Result</h4>
              
            </div>}
            {checked?.length > 0 &&
            <div id="user-tbl_wrapper" className="dataTables_wrapper no-footer">
              <table
                id="projects-tbl"
                className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
              >
               <thead>
                  <tr>
                    <th className="sorting_asc_11">
                      <div className="form-check custom-checkbox ms-0">
                        <input
                          type="checkbox"
                          className="form-check-input checkAllInput"
                          required=""
                          onClick={() => handleCheckedAll(unchecked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="checkAll"
                        ></label>
                      </div>
                    </th>
                    <th>Company Name</th>
                    <th>Registration No.</th>
                    <th>Email</th>
                    <th>Office</th>
                    <th>Reg Date</th>
                    <th>Reg End Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {checked.map((item, index) => (
                    <tr key={index}>
                      <td className="sorting_20">
                        <div className="form-check11custom-checkbox">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`user-${item._id}`}
                            checked={item.inputchecked}
                            onChange={() => handleChecked(item._id)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`user-${item._id}`}
                          ></label>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <p className="mb-0 ms-2">{item.companyName}</p>
                        </div>
                      </td>
                      <td>{item.companyRegNo}</td>
                      <td>{item.email}</td>
                      <td>{item.office}</td>
                      <td>{dateFormat(item.regDate)}</td>
                      <td>{dateFormat(item.regEndDate)}</td>
                      <td>
                        <Status status={item.status} />
                      </td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            as="div"
                            className="btn-link i-false"
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
                                stroke="#737B8B"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
                                stroke="#737B8B"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
                                stroke="#737B8B"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            className="dropdown-menu-right"
                            align="end"
                          >
                            <Dropdown.Item
                              onClick={(e) => {
                                nav(`/add-company?id=${item._id}&mode=view`);
                              }}
                            >
                              View
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => {
                                nav(`/add-company?id=${item._id}&mode=edit`);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info">
                  Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                  {companies.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers justify-content-center"
                  id="example2_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    to="#"
                    onClick={prePage}
                  >
                    <i className="fa-solid fa-angle-left" />
                  </Link>
                  <span>
                    {number.map((n, i) => (
                      <Link
                        className={`paginate_button ${
                          currentPage === n ? "current" : ""
                        } `}
                        key={i}
                        onClick={() => changeCPage(n)}
                      >
                        {n}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    to="#"
                    onClick={nextPage}
                  >
                    <i className="fa-solid fa-angle-right" />
                  </Link>
                </div>
              </div>
            </div>}
          </div>
              </div>
              </div>
					</Col>
				</Row>
			</div>
      <SendEmail ref={userdata} Title="Send Email" 
        token={token} 
        data={checked.filter(d=>d.inputchecked)} 
        isCompany={true}
        user={loggedInUser}
        //hint={"Please use #title#, #firstName# , #lastName# to dynamically map values"}
      />
      <SendLetter 
      ref={sendletterref}
      token={token} 
      data={checked.filter(d=>d.inputchecked)}
      isCompany={true}
      user={loggedInUser}
      />
      
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    loggedInUser: getLoggedInUser(state),

  };
};

export default withRouter(connect(mapStateToProps)(SearchCompany));
